<template>
	<b-modal
		id="experience-modal"
		centered
		hide-header
		hide-footer
		modal-class="experience-modal"
		size="md"
		backdrop-class="onboarding-modal-backdrop"
		no-close-on-backdrop
		no-close-on-esc
	>
		<article class="profile-setup">
			<template v-if="!showOnboardingLoader">
				<!-- Header -->
				<header
					class="setup-header d-flex align-items-baseline justify-content-between"
				>
					<div class="">
						<p class="fam-mont fw-M fs-16 text-8cgrey mb-1">PROFILE SETUP</p>
						<h2 class="color-2E425D fam-mont fs-18 fw-B">
							{{
								step == 1
									? `What's your experience level?`
									: step == 2
									? "Add your skills"
									: `Why are you on Hire3x?`
							}}
						</h2>
					</div>
					<!-- <img
						src="@/assets/newdesign/resumeclinic/mobileclose.svg"
						class="mobilecloseicon pointer rotate-on-hover"
						alt=""
						id="hideinlaptop"
					/> -->
				</header>

				<!-- Options -->
				<main
					v-show="step === 1"
					class="mobile-main-content-screen2 mobd-flex mob-align-center"
				>
					<div class="mobd-flex mob-justify-center mob-flex-column mob-w-100">
						<section
							class="exp-options mt-5 mob-w-100"
							:class="{
								'justify-content-between': isLaptop,
							}"
						>
							<button
								class="exp-card flex-column d-flex align-items-center justify-content-center position-relative mob-w-100"
								:class="{
									active: selected === 'fresher',
								}"
								@click="onSelectExperience('fresher')"
							>
								<div class="overlay2 overlay"></div>

								<img src="@/assets/Onboarding/fresher.svg" alt="Fresher" />
								<span
									class="color-2E425D fam-mont fs-18 fw-LM"
									:class="{ 'text-white': selected === 'fresher' }"
									>Fresher</span
								>
								<img
									src="@/assets/Onboarding/selectedtick.svg"
									v-if="selected === 'fresher'"
									class="selected-tick"
									alt=""
								/>
							</button>

							<button
								class="exp-card flex-column d-flex align-items-center justify-content-center mob-w-100"
								:class="{ active: selected === 'experienced', isla }"
								@click="onSelectExperience('experienced')"
							>
								<div class="overlay2 overlay"></div>

								<img
									src="@/assets/Onboarding/experience.svg"
									alt="Experienced"
								/>
								<span
									class="color-2E425D fam-mont fs-18 fw-LM"
									:class="{ 'text-white': selected === 'experienced' }"
									>Experienced</span
								>
								<img
									src="@/assets/Onboarding/selectedtick.svg"
									v-if="selected === 'experienced'"
									class="selected-tick"
									alt=""
								/>
							</button>
						</section>

						<b-col v-if="selected === 'experienced'" class="mobpx-0 px-0">
							<div
								class="d-flex align-items-center justify-content-between my-4 mobflexcolumn mob-w-100"
							>
								<div class="candash-modal-label w35 mob-w-100">
									Current Designation<span class="asterik">&nbsp;*</span>
								</div>
								<div class="w65 mob-w-100">
									<b-form-input
										v-model="$v.form.designation.$model"
										placeholder="Enter here"
										type="text"
										class="laptopinput"
										:class="{ 'laptopinput-error': $v.form.designation.$error }"
									>
									</b-form-input>
									<small
										v-if="
											$v.form.designation.$error &&
											!$v.form.designation.required
										"
										class="onboard-error-text skills"
									>
										Current Designation is required.
									</small>
									<small
										v-else-if="
											$v.form.designation.$error &&
											!$v.form.designation.maxLength
										"
										class="onboard-error-text skills"
									>
										Max Char Exceeded
									</small>
								</div>
							</div>
						</b-col>
						<b-col v-if="selected === 'experienced'" class="mobpx-0 px-0">
							<div
								class="d-flex align-items-center justify-content-between mt-4 w-100 mobmt-0"
							>
								<div class="candash-modal-label mobw50 w35">
									Years of Experience<span class="asterik">&nbsp;*</span>
								</div>
								<div>
									<b-form-input
										v-model="$v.form.totalYearsOfExp.$model"
										type="number"
										inputmode="decimal"
										min="1"
										max="40"
										step="0.01"
										class="laptopinput w-80"
										:class="{
											'laptopinput-error': $v.form.totalYearsOfExp.$error,
										}"
									>
									</b-form-input>
									<small
										v-if="
											$v.form.totalYearsOfExp.$error &&
											!$v.form.totalYearsOfExp.required
										"
										class="onboard-error-text experience"
									>
										Years of Experience is required
									</small>
									<small
										v-if="
											$v.form.totalYearsOfExp.$error &&
											$v.form.totalYearsOfExp.required &&
											(!$v.form.totalYearsOfExp.minValue ||
												!$v.form.totalYearsOfExp.maxValue)
										"
										class="onboard-error-text experience"
									>
										Only values from 1 to 40 are allowed
									</small>
									<small
										v-if="
											$v.form.totalYearsOfExp.$error &&
											$v.form.totalYearsOfExp.required &&
											$v.form.totalYearsOfExp.minValue &&
											$v.form.totalYearsOfExp.maxValue &&
											!$v.form.totalYearsOfExp.validDecimal
										"
										class="onboard-error-text experience"
									>
										Invalid experience
									</small>
								</div>
							</div>
						</b-col>
						<div
							v-if="selected === 'experienced'"
							class="slider-container mb-3"
						>
							<input
								type="range"
								min="1"
								max="40"
								:value="form.totalYearsOfExp || 1"
								@input="
									$v.form.totalYearsOfExp.$model = Number($event.target.value)
								"
								class="exp-slider"
								:style="sliderStyle"
							/>
						</div>
					</div>
				</main>
				<main v-show="step === 2" class="mt-4 mobile-step2-main">
					<section v-if="skills.length" class="skill-container">
						<div>
							<span class="fw-B fs-16 fam-mont text-blue"
								>{{ skills.length }}
							</span>
							<span class="fw-LM fs-13 fam-mont color-344054"
								>Added Skills</span
							>
						</div>
						<div class="d-flex flex-wrap gap-2 mt-2">
							<div
								v-for="(skill, index) in skills"
								:key="`${skill.skillName}-${index}`"
								class="px-2 py-1 pointer position-relative pr-4"
								:class="
									selectedSkillIndex === index ? 'skill-pill-sel' : 'skill-pill'
								"
								@click="selectSkill(index)"
							>
								{{ skill.skillName }}
								<img
									v-if="selectedSkillIndex === index"
									class="skill-tick-icon"
									src="@/assets/newdesign/dashboard/whiteTick.svg"
									alt=""
								/>
								<img
									v-else
									class="skill-delete-icon pointer"
									src="@/assets/newdesign/dashboard/roundBlueCross.svg"
									alt=""
									@click.stop="removeSkill(index)"
								/>
							</div>
						</div>
					</section>
					<b-col class="mobpx-0 px-0">
						<div
							class="d-flex align-items-center justify-content-between my-4 mobflexcolumn"
						>
							<div id="hideinmobile" class="candash-modal-label w35 mob-w-100">
								Skill<span class="asterik">&nbsp;*</span>
							</div>
							<div class="w65 mob-w-100">
								<Selectwithsearch
									id="onboardingSkill"
									:mandatory="true"
									:label="!isLaptop ? 'Skill' : null"
									placeholder="Enter here"
									:showError="shouldShowSkillInputError()"
									:vmodel="skillInput"
									@select-value="onSkillInputChange"
								/>
								<small
									v-if="shouldShowSkillInputError()"
									class="onboard-error-text skills step2"
								>
									{{ getSkillInputError() }}
								</small>
							</div>
						</div>
					</b-col>
					<b-col class="mobpx-0 px-0">
						<div
							class="d-flex align-items-baseline justify-content-between my-4 mobflexcolumn"
						>
							<div class="candash-modal-label w35 w-100">
								Expertise Level<span class="asterik">&nbsp;*</span>
							</div>
							<div
								class="w65 d-flex align-items-center gap-2 mobflexwrap w-100 mobmt8"
							>
								<div
									class="fw-R fs-12 fam-mont pointer skill-expertise-pill"
									:class="{
										'selected-skill-expertise text-white fw-LM':
											selectedExpertiseLevel === 'beginner',
										'ob-skilltags-disabled not-allowed':
											!normalizeSkillName(skillInput),
									}"
									@click="
										normalizeSkillName(skillInput) &&
											selectExpertise('beginner')
									"
								>
									Beginner
								</div>
								<div
									class="fw-R fs-12 fam-mont pointer skill-expertise-pill"
									:class="{
										'selected-skill-expertise text-white fw-LM':
											selectedExpertiseLevel === 'intermediate',
										'ob-skilltags-disabled not-allowed':
											!normalizeSkillName(skillInput),
									}"
									@click="
										normalizeSkillName(skillInput) &&
											selectExpertise('intermediate')
									"
								>
									Intermediate
								</div>
								<div
									class="fw-R fs-12 fam-mont pointer skill-expertise-pill"
									:class="{
										'selected-skill-expertise text-white fw-LM':
											selectedExpertiseLevel === 'advanced',
										'ob-skilltags-disabled not-allowed':
											!normalizeSkillName(skillInput),
									}"
									@click="
										normalizeSkillName(skillInput) &&
											selectExpertise('advanced')
									"
								>
									Advanced
								</div>
								<div
									class="fw-R fs-12 fam-mont pointer skill-expertise-pill"
									:class="{
										'selected-skill-expertise text-white fw-LM':
											selectedExpertiseLevel === 'expert',
										'ob-skilltags-disabled not-allowed':
											!normalizeSkillName(skillInput),
									}"
									@click="
										normalizeSkillName(skillInput) && selectExpertise('expert')
									"
								>
									Expert
								</div>
							</div>
						</div>
						<small
							id="hideinmobile"
							v-if="$v.selectedExpertiseLevel.$error"
							class="onboard-error-text expertise d-block text-right"
						>
							{{ getExpertiseError() }}
						</small>
					</b-col>
					<div class="d-flex align-items-center justify-content-end gap-3 mt-3">
						<template v-if="selectedSkillIndex !== null">
							<div
								class="bold-bluetxt"
								:class="
									hasSkillEditChanges ? 'pointer' : 'opac-5 defaultCursor'
								"
								@click="discardSelectedSkill"
							>
								Discard
							</div>
							<div class="blueline"></div>
							<div class="bold-bluetxt pointer" @click="updateSelectedSkill">
								Update
							</div>
						</template>
						<div
							class="d-flex align-items-center justify-content-end"
							:class="{
								'justify-content-between w-100':
									$v.selectedExpertiseLevel.$error && !isLaptop,
							}"
							v-else
						>
							<small
								id="hideinlaptop"
								v-if="$v.selectedExpertiseLevel.$error"
								class="onboard-error-text expertise d-block mt-0"
								style="position: unset"
							>
								{{ getExpertiseError() }}
							</small>
							<div
								class="d-flex align-items-center bold-bluetxt gap-1"
								:class="canAddSkill ? 'pointer' : 'opac-5 defaultCursor'"
								@click="canAddSkill && handleAddSkill()"
							>
								<img
									src="../../assets/newdesign/dashboard/blueRoundAdd.svg"
									alt=""
								/>
								Add
							</div>
						</div>
					</div>
					<small
						v-if="skillsApiError"
						class="onboard-error-text d-block text-right"
					>
						{{ skillsApiError }}
					</small>
				</main>
				<main v-show="step === 3" class="step3-main-content">
					<section class="goal-grid mt-4">
						<button
							v-for="goal in goals"
							:key="goal.id"
							class="h-140-w-168 exp-card flex-column d-flex align-items-center justify-content-center position-relative"
							:class="{ active: selectedGoals.includes(goal.id) }"
							@click="toggleGoalSelection(goal.id)"
						>
							<div class="overlay"></div>

							<img :src="goal.icon" alt="" />

							<span
								class="fam-mont fs-14 fw-M text-center"
								:class="{
									'text-white fw-B': selectedGoals.includes(goal.id),
									'text-blue ': !selectedGoals.includes(goal.id),
								}"
							>
								{{ goal.label }}
							</span>

							<img
								src="@/assets/Onboarding/selectedtick.svg"
								v-if="selectedGoals.includes(goal.id)"
								class="selected-tick"
							/>
							<img
								class="selected-tick"
								src="@/assets/Onboarding/emptyradio.svg"
								v-else
								alt=""
							/>
						</button>
					</section>
					<b-col class="mobpx-0 px-0">
						<div class="d-flex justify-content-between my-4 mob-flex-column">
							<div class="w35 w-100">
								<div class="candash-modal-label">
									Select Location<span class="asterik">&nbsp;*</span>
								</div>
								<div class="fw-R fs-12 text-8cgrey fam-lato">
									This will help us create and scout you for the best jobs in
									that area.
								</div>
							</div>
							<div class="w65 w-100">
								<LocationSearch
									id="location"
									label=""
									type="text"
									from="onboarding"
									:mandatory="false"
									placeholder="Enter here"
									:vmodel="locationInput"
									:showError="$v.locationInput.$error"
									@select-value="onLocationChange"
								/>
								<small
									v-if="$v.locationInput.$error"
									class="onboard-error-text location d-block"
								>
									{{ getLocationError() }}
								</small>
							</div>
						</div>
						<small
							v-if="goalsApiError"
							class="onboard-error-text d-block text-right"
						>
							{{ goalsApiError }}
						</small>
						<small
							v-if="summaryApiError"
							class="onboard-error-text d-block text-right"
						>
							{{ summaryApiError }}
						</small>
					</b-col>
				</main>
				<hr style="border-top: 1px solid rgb(171 171 171)" />
				<!-- Footer -->
				<footer class="modal-footer-sec">
					<nav class="steps">
						<span class="dot" :class="{ active: step === 1 }"></span>
						<span class="dot" :class="{ active: step === 2 }"></span>
						<span class="dot" :class="{ active: step === 3 }"></span>
					</nav>

					<div
						v-if="step === 1"
						class="fw-M fam-mont fs-13 text-blue d-flex align-items-center pointer mobile-upload-resume"
						:class="{
							'bottom-85': selected !== 'experienced' || selected === null,
						}"
						@click="$emit('open-upload-resume')"
					>
						<img
							src="../../assets/Onboarding/uploadicon.svg"
							alt=""
							class="mr-2"
						/>
						Upload my Resume
					</div>

					<b-button
						v-if="step === 1"
						class="candash-addBtn"
						:disabled="isSubmitting || (step === 1 && !canContinueStepOne)"
						@click="handleContinue"
					>
						Continue
					</b-button>

					<div
						v-else-if="step === 3"
						class="d-flex align-items-center gap-3 fw-LM"
					>
						<b-button class="onboard-back-btn" @click="goBackToStepTwo">
							Back
						</b-button>
						<b-button
							class="candash-addBtn"
							:disabled="!canConfirmStepThree"
							@click="handleConfirmGoals"
						>
							Confirm & Next
						</b-button>
					</div>

					<div v-else class="d-flex align-items-center gap-3 ml-auto">
						<b-button class="onboard-back-btn" @click="goBackToStepOne">
							Back
						</b-button>
						<b-button
							class="candash-addBtn"
							:disabled="!canConfirmStepTwo"
							@click="handleConfirmSkills"
						>
							Confirm & Next
						</b-button>
					</div>
				</footer>
			</template>

			<Spinner
				v-if="showOnboardingLoader"
				:id="'modal'"
				:from="isLaptop ? '' : 'onboarding'"
				:loaderText="onboardingLoaderText"
			/>
		</article>
	</b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import {
	requiredIf,
	minValue,
	maxValue,
	minLength,
	maxLength,
} from "vuelidate/lib/validators";
import {
	postCandInfo,
	getCandidatePrimaryProfile,
} from "@/utils/apiFunctions";
import {
	getProcessedToken,
	ServiceCandidate,
	ServiceCandidateParser,
} from "@/utils/request";
import toast from "@/components/mixin/toast";
import Selectwithsearch from "@/components/selectwithsearch.vue";
import LocationSearch from "@/components/LocationSearch.vue";
import Spinner from "@/components/fixedcomponents/Spinner.vue";

export default {
	mixins: [toast],
	components: {
		Selectwithsearch,
		LocationSearch,
		Spinner,
	},
	props: {
		onboardingGateReady: {
			type: Boolean,
			default: false,
		},
		roadmapSkills: {
			type: [String, Array],
			default: null,
		},
		isLaptop: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		// Watchers for all persistent draft fields, including the active step.
		step() {
			this.saveDraft();
		},
		selected() {
			this.saveDraft();
		},
		form: {
			handler() {
				this.saveDraft();
			},
			deep: true,
		},
		skills: {
			handler() {
				this.saveDraft();
			},
			deep: true,
		},
		selectedGoals: {
			handler() {
				this.saveDraft();
			},
			deep: true,
		},
		locationInput() {
			this.saveDraft();
		},
	},
	async mounted() {
		this.hasRoadmapSkillsFlow =
			this.parseRoadmapSkillsQuery(
				this.roadmapSkills || this.$route?.query?.roadmapSkills
			).length > 0;
		this.getOrCreateOnboardingSessionId();

		await this.fetchAndHydrateProfile();

		this.$nextTick(() => {
			if (this.step !== null && this.isOnboardingGateReady()) {
				this.$bvModal.show("experience-modal");
			}
		});
	},
	data() {
		return {
			modalOpen: true,
			hasRoadmapSkillsFlow: false,
			selected: null,
			selectedGoals: [],
			form: {
				designation: "",
				totalYearsOfExp: "",
			},
			locationInput: "",
			skillInput: "",
			skills: [],
			skillSuggestionOptions: [],
			skillSearchTimer: null,
			selectedSkillIndex: null,
			selectedSkillSnapshot: null,
			selectedExpertiseLevel: "",
			skillsApiError: "",
			goalsApiError: "",
			summaryApiError: "",
			lastDraftSnapshot: "",
			savedOnboardingStep: null,
			onboardingSessionId: "",
			max: 40,
			step: 1,
			isInitialFetching: false,
			isSubmitting: false,
			isSubmittingSkills: false,
			isSubmittingGoals: false,
			isGeneratingSummary: false,
			isPostingSummary: false,
			goalIdToApiMapping: {
				upskill: "courses",
				assessment: "assessments",
				jobs: "jobs",
				interviews: "interviews",
				instructor: "instructor",
				panelist: "panelist",
			},
			goals: [
				{
					id: "upskill",
					label: "Upskill with Courses",
					icon: require("@/assets/Onboarding/activeupskillscourse.svg"),
				},
				{
					id: "assessment",
					label: "Take Assessments",
					icon: require("@/assets/Onboarding/takeasmnt.svg"),
				},
				{
					id: "jobs",
					label: "Search & Apply for Jobs",
					icon: require("@/assets/Onboarding/searchjobs.svg"),
				},
				{
					id: "interviews",
					label: "Prepare for Interviews",
					icon: require("@/assets/Onboarding/prepinterview.svg"),
				},
				{
					id: "instructor",
					label: "Become an Instructor",
					icon: require("@/assets/Onboarding/becomeinst.svg"),
				},
				{
					id: "panelist",
					label: "Join as a Panelist",
					icon: require("@/assets/Onboarding/joinaspanelist.svg"),
				},
			],
		};
	},
	validations() {
		return {
			form: {
				designation: {
					required: requiredIf(function () {
						return this.selected === "experienced";
					}),
					maxLength: maxLength(24),
				},
				totalYearsOfExp: {
					required: requiredIf(function () {
						return this.selected === "experienced";
					}),
					minValue: minValue(1),
					maxValue: maxValue(40),
					validDecimal: (value) => {
						if (value === "" || value === null || value === undefined)
							return true;
						return /^\d+(\.\d{1,2})?$/.test(String(value));
					},
				},
			},
			skillInput: {
				required: (value) => !!this.normalizeSkillName(value),
				noDuplicate: (value) =>
					this.findDuplicateSkillIndex(value, this.selectedSkillIndex) === -1,
			},
			selectedExpertiseLevel: {
				required: (value) => !!value,
			},
			selectedGoals: {
				minLength: minLength(1),
			},
			locationInput: {
				required: (value) => !!String(value || "").trim(),
			},
		};
	},
	computed: {
		...mapGetters("candidateVUEX", {
			candidateInfo: "getcandidateInfo",
			primaryCandidateInfo: "getPrimaryCandidateInfo",
		}),
		canContinueStepOne() {
			return this.hasValidStepOneData();
		},
		canConfirmStepTwo() {
			if (this.step !== 2) return true;
			if (!this.hasValidStepOneData()) return false;
			if (this.isSubmittingSkills || this.skills.length === 0) return false;
			return this.skills.every((skill) => !!skill.expertiseLevel);
		},
		canConfirmStepThree() {
			if (this.step !== 3) return true;
			if (this.isOnboardingBusy) {
				return false;
			}
			const hasGoal = this.selectedGoals.length >= 1;
			const hasLocation = !!String(this.locationInput || "").trim();
			return hasGoal && hasLocation;
		},
		isOnboardingBusy() {
			return (
				this.isInitialFetching ||
				this.isSubmittingGoals ||
				this.isGeneratingSummary ||
				this.isPostingSummary
			);
		},
		showOnboardingLoader() {
			return this.isOnboardingBusy;
		},
		onboardingLoaderText() {
			if (this.isGeneratingSummary) {
				return ["Generating your profile summary..."];
			}
			if (this.isPostingSummary) {
				return ["Saving your profile summary..."];
			}
			return ["Setting up your experience..."];
		},
		filteredSkillOptions() {
			return this.skillSuggestionOptions.filter((option) => {
				const duplicateIndex = this.findDuplicateSkillIndex(
					option.label,
					this.selectedSkillIndex
				);
				return duplicateIndex === -1;
			});
		},
		canAddSkill() {
			if (this.selectedSkillIndex !== null) return false;
			if (!this.normalizeSkillName(this.skillInput)) return false;
			if (!this.selectedExpertiseLevel) return false;
			return this.findDuplicateSkillIndex(this.skillInput) === -1;
		},
		hasSkillEditChanges() {
			if (this.selectedSkillIndex === null || !this.selectedSkillSnapshot) {
				return false;
			}
			const normalizedCurrent = this.normalizeSkillName(this.skillInput || "");
			const normalizedOriginal = this.normalizeSkillName(
				this.selectedSkillSnapshot.skillName || ""
			);
			const expertiseChanged =
				(this.selectedExpertiseLevel || "") !==
				(this.selectedSkillSnapshot.expertiseLevel || "");
			return normalizedCurrent !== normalizedOriginal || expertiseChanged;
		},
		sliderStyle() {
			if (!this.form.totalYearsOfExp) {
				return { background: "#d0d5dd" };
			}

			const min = 1;
			const max = 40;
			let value = Number(this.form.totalYearsOfExp);

			// Clamp value between min and max
			if (value < min) value = min;
			if (value > max) value = max;

			// Calculate ratio from 0 to 1
			const ratio = (value - min) / (max - min);
			// Calculate exact center of the thumb (22px thumb width -> 11px radius)
			const percentStr = `calc(${ratio * 100}% + ${11 - ratio * 22}px)`;

			return {
				background: `linear-gradient(
          to right,
          #20639b 0%,
          #20639b ${percentStr},
          #d0d5dd ${percentStr},
          #d0d5dd 100%
        )`,
			};
		},
	},

	methods: {
		isOnboardingGateReady() {
			return this.onboardingGateReady === true;
		},
		shouldShowSkillInputError() {
			if (!this.$v.skillInput.$error) return false;

			const isEmpty = !this.normalizeSkillName(this.skillInput);
			const hasAddedSkills = this.skills.length > 0;
			const isAddMode = this.selectedSkillIndex === null;

			// Suppress required error after successful add clears input.
			if (isAddMode && isEmpty && hasAddedSkills) return false;

			return true;
		},
		getSkillInputError() {
			if (this.$v.skillInput.$error) {
				if (!this.$v.skillInput.required) return "Skill is required.";
				if (!this.$v.skillInput.noDuplicate)
					return "This skill is already added.";
			}
			return "";
		},
		getExpertiseError() {
			if (this.$v.selectedExpertiseLevel.$error) {
				if (!this.$v.selectedExpertiseLevel.required)
					return "Please select an expertise level.";
			}
			return "";
		},
		getLocationError() {
			if (this.$v.locationInput.$error) {
				if (!this.$v.locationInput.required) return "Location is required.";
			}
			return "";
		},
		hasValidStepOneData() {
			if (!this.selected) return false;
			if (this.selected === "fresher") return true;
			return !this.$v.form.$invalid;
		},
		goBackToStepOne() {
			this.exitSkillEditMode();
			this.step = 1;
		},
		goBackToStepTwo() {
			this.step = 2;
		},
		resetStepThreeState() {
			this.selectedGoals = [];
			this.locationInput = "";
			this.goalsApiError = "";
			this.summaryApiError = "";
			this.isSubmittingGoals = false;
			this.isGeneratingSummary = false;
			this.isPostingSummary = false;
			this.$v.selectedGoals.$reset();
			this.$v.locationInput.$reset();
		},
		resetStepTwoState() {
			this.skillInput = "";
			this.skills = [];
			this.skillSuggestionOptions = [];
			this.selectedSkillIndex = null;
			this.selectedSkillSnapshot = null;
			this.selectedExpertiseLevel = "";
			this.skillsApiError = "";
			this.isSubmittingSkills = false;
			this.$v.skillInput.$reset();
			this.$v.selectedExpertiseLevel.$reset();
		},
		normalizeSkillName(value) {
			return String(value || "")
				.trim()
				.replace(/\s+/g, " ")
				.toLowerCase();
		},
		findDuplicateSkillIndex(skillName, excludeIndex = null) {
			const normalized = this.normalizeSkillName(skillName);
			if (!normalized) return -1;
			return this.skills.findIndex((skill, index) => {
				if (excludeIndex !== null && index === excludeIndex) return false;
				return this.normalizeSkillName(skill.skillName) === normalized;
			});
		},
		mapRoadmapExpertiseLevel(value) {
			const mapping = {
				1: "beginner",
				2: "intermediate",
				3: "advanced",
				4: "expert",
			};
			const numericLevel = Number(value);
			return mapping[numericLevel] || "";
		},
		parseRoadmapSkillEntry(rawEntry) {
			const entry = String(rawEntry || "").trim();
			if (!entry) {
				return {
					skillName: "",
					expertiseLevel: "",
				};
			}

			const match = entry.match(/^(.*?):\s*([1-4])\s*$/);
			if (!match) {
				return {
					skillName: entry,
					expertiseLevel: "",
				};
			}

			return {
				skillName: String(match[1] || "").trim(),
				expertiseLevel: this.mapRoadmapExpertiseLevel(match[2]),
			};
		},
		onSkillFocus() {
		},
		onSkillInputChange(value) {
			this.skillInput = value || "";
			if (!this.normalizeSkillName(this.skillInput)) {
				this.selectedExpertiseLevel = "";
			}
			this.$v.skillInput.$touch();
			this.saveDraft();
		},
		onLocationChange(value) {
			this.locationInput = value || "";
			this.$v.locationInput.$touch();
			// saveDraft() not needed — the `locationInput` watcher handles it.
		},
		toggleGoalSelection(goalId) {
			const index = this.selectedGoals.indexOf(goalId);
			if (index === -1) {
				this.selectedGoals.push(goalId);
			} else {
				this.selectedGoals.splice(index, 1);
			}
			this.goalsApiError = "";
			this.saveDraft();
		},
		getMappedGoalsForApi() {
			return this.selectedGoals
				.map((goalId) => this.goalIdToApiMapping[goalId])
				.filter(Boolean);
		},
		handleAddSkill() {
			this.$v.skillInput.$touch();
			this.$v.selectedExpertiseLevel.$touch();

			if (this.$v.skillInput.$invalid) {
				this.skillsApiError = "";
				return;
			}
			if (this.$v.selectedExpertiseLevel.$invalid) {
				this.skillsApiError = "";
				return;
			}

			this.skills.push({
				skillName: this.skillInput.trim().replace(/\s+/g, " "),
				expertiseLevel: this.selectedExpertiseLevel,
				yearsOfExp: "",
			});
			this.skillInput = "";
			this.selectedExpertiseLevel = "";
			this.selectedSkillIndex = null;
			this.selectedSkillSnapshot = null;
			this.$v.skillInput.$reset();
			this.$v.selectedExpertiseLevel.$reset();
			this.saveDraft();
		},
		exitSkillEditMode() {
			this.selectedSkillIndex = null;
			this.selectedSkillSnapshot = null;
			this.skillInput = "";
			this.selectedExpertiseLevel = "";
		},
		selectSkill(index) {
			const selectedSkill = this.skills[index];
			if (!selectedSkill) return;
			this.selectedSkillIndex = index;
			this.selectedSkillSnapshot = { ...selectedSkill };
			this.skillInput = selectedSkill.skillName || "";
			this.selectedExpertiseLevel = selectedSkill.expertiseLevel || "";
			this.saveDraft();
		},
		selectExpertise(level) {
			this.selectedExpertiseLevel = level;
			this.$v.selectedExpertiseLevel.$touch();
			this.saveDraft();
		},
		updateSelectedSkill() {
			this.$v.skillInput.$touch();
			this.$v.selectedExpertiseLevel.$touch();

			if (this.selectedSkillIndex === null) {
				this.skillsApiError = "";
				return;
			}
			if (this.$v.skillInput.$invalid) {
				this.skillsApiError = "";
				return;
			}
			if (this.$v.selectedExpertiseLevel.$invalid) {
				this.skillsApiError = "";
				return;
			}

			this.$set(this.skills, this.selectedSkillIndex, {
				...this.skills[this.selectedSkillIndex],
				skillName: this.skillInput.trim().replace(/\s+/g, " "),
				expertiseLevel: this.selectedExpertiseLevel,
			});
			this.exitSkillEditMode();
			this.$v.skillInput.$reset();
			this.$v.selectedExpertiseLevel.$reset();
			// saveDraft() not needed — the `skills` deep watcher catches the $set mutation above.
		},
		discardSelectedSkill() {
			if (this.selectedSkillIndex === null || !this.hasSkillEditChanges) return;
			this.exitSkillEditMode();
			this.$v.skillInput.$reset();
			this.$v.selectedExpertiseLevel.$reset();
		},
		removeSkill(index) {
			if (index < 0 || index >= this.skills.length) return;
			this.skills.splice(index, 1);
			if (this.selectedSkillIndex === index) {
				this.exitSkillEditMode();
				// saveDraft() not needed — the `skills` deep watcher catches splice mutations.
				return;
			}
			if (this.selectedSkillIndex !== null && index < this.selectedSkillIndex) {
				this.selectedSkillIndex = this.selectedSkillIndex - 1;
			}
			// saveDraft() not needed — the `skills` deep watcher catches splice mutations.
		},
		getCandidateEmail() {
			return (
				this.candidateInfo?.email || this.primaryCandidateInfo?.email || ""
			);
		},
		async handleConfirmSkills() {
			this.skillsApiError = "";

			if (!this.hasValidStepOneData()) {
				this.step = 1;
				this.errorModal(
					"Error",
					"Please complete step 1 before confirming skills."
				);
				return;
			}

			if (!this.canConfirmStepTwo) {
				return;
			}

			const candidateId = this.getCandidateId();
			if (!candidateId) return;

			const payload = {
				id: candidateId,
				email: this.getCandidateEmail(),
				parser: false,
				onboardingStep: 2,
				skills: this.skills.map((skill, index) => ({
					skillName: skill.skillName,
					expertiseLevel: (skill.expertiseLevel || "").toLowerCase(),
					yearsOfExp: skill.yearsOfExp ?? "",
					priorityID: index + 1,
				})),
			};

			const userID = getProcessedToken();
			const headers = userID ? { userID } : {};

			this.isSubmittingSkills = true;
			try {
				const response = await ServiceCandidate({
					url: "can/candidate-skills/",
					method: "post",
					headers,
					data: payload,
				});
				if (response?.status >= 200 && response?.status < 300) {
					this.setLastSavedStep(2);
					this.step = 3;
				} else {
					this.skillsApiError = "Unable to save skills. Please try again.";
					this.errorModal("Error", "Unable to save skills. Please try again.");
				}
			} catch (error) {
				this.skillsApiError = "Unable to save skills. Please try again.";
				this.errorModal("Error", "Unable to save skills. Please try again.");
			} finally {
				this.isSubmittingSkills = false;
			}
		},
		async handleConfirmGoals() {
			this.$v.selectedGoals.$touch();
			this.$v.locationInput.$touch();
			this.summaryApiError = "";

			if (this.$v.selectedGoals.$invalid) {
				this.goalsApiError = "";
				return;
			}
			if (this.$v.locationInput.$invalid) {
				this.goalsApiError = "";
				return;
			}

			const candidateId = this.getCandidateId();
			if (!candidateId) return;

			const payload = {
				id: candidateId,
				city: String(this.locationInput || "").trim(),
				onboardingStep: 3,
				goals: this.getMappedGoalsForApi(),
			};

			const userID = getProcessedToken();
			const headers = userID ? { userID } : {};

			this.isSubmittingGoals = true;
			let goalsResponse;
			try {
				goalsResponse = await ServiceCandidate({
					url: "can/candidate-information/",
					method: "post",
					headers,
					data: payload,
				});
			} catch (error) {
				this.errorModal("Error", "Something went wrong. Please try again.");
				return;
			} finally {
				this.isSubmittingGoals = false;
			}

			if (!(goalsResponse?.status >= 200 && goalsResponse?.status < 300)) {
				this.goalsApiError =
					"Unable to save goals and location. Please try again.";
				this.errorModal(
					"Error",
					"Unable to save goals and location. Please try again."
				);
				return;
			}
			this.setLastSavedStep(3);

			this.isGeneratingSummary = true;
			let summaryText = "";
			try {
				summaryText = await this.generateProfileSummary(headers);
			} catch (error) {
				return;
			} finally {
				this.isGeneratingSummary = false;
			}

			if (!summaryText) {
				this.summaryApiError = "Unable to generate summary. Please try again.";
				return;
			}

			this.isPostingSummary = true;
			try {
				const summarySaveResponse = await this.postGeneratedSummary(
					candidateId,
					summaryText,
					headers
				);
				if (
					!(
						summarySaveResponse?.status >= 200 &&
						summarySaveResponse?.status < 300
					)
				) {
					this.errorModal("Error", "Unable to save summary. Please try again.");
					this.isPostingSummary = false;
					return;
				}
				const redirectRoute = this.getPostOnboardingRedirectRoute();
				this.clearDraft();
				this.clearOnboardingStorage();

				// Refresh candidate info to ensure store has database_demographics=true before redirect
				// try {
				// 	await getCandidatePrimaryProfile();
				// } catch (error) {
				// 	console.warn(
				// 		"Failed to refresh candidate info after onboarding completion",
				// 		error
				// 	);
				// }

				const fromTraining =
					this.$route && this.$route.query && this.$route.query.fromTraining;
				const returnUrl =
					this.$route && this.$route.query && this.$route.query.returnUrl;
				this.$store.commit("candidateVUEX/setOnboardingActive", false);
				if (fromTraining && returnUrl) {
					window.location.href = decodeURIComponent(returnUrl);
					return;
				}

				// if (redirectRoute) {
				// 	await this.$router.push(redirectRoute);
				// 	return;
				// }
				this.$emit("close-modal");
				this.$bvModal.hide("experience-modal");
				return;
			} catch (error) {
				this.errorModal("Error", "Unable to save summary. Please try again.");
			}
		},
		getPostOnboardingRedirectRoute() {
			const byCompanyFlag = this.$route?.query?.bycompany;
			if (byCompanyFlag !== undefined) {
				const company = this.$route?.query?.company;
				const role = this.$route?.query?.role;
				return {
					name: "InterviewSkills",
					query: {
						bycompany: 1,
						company: company || "",
						role: role || "",
					},
				};
			}

			if (this.hasRoadmapSkillsFlow) {
				const interviewSkill = this.skills.find(
					(skill) => skill && skill.skillName
				);
				if (!interviewSkill) {
					return null;
				}

				return {
					name: "InterviewSkills",
					query: {
						byskill: true,
						skill: interviewSkill.skillName,
						index: 0,
						rec: 0,
						byCompany: 0,
					},
				};
			}
			// Default: stay on the current homepage and close the modal.
			return null;
		},
		buildSummaryPayload() {
			const baseCandidate = {
				...(this.primaryCandidateInfo || {}),
				...(this.candidateInfo || {}),
			};

			const normalizedExperienceLevel =
				this.selected === "fresher" ? "fresher" : "intermediate";
			const normalizedExperienceLabel =
				this.selected === "fresher" ? "Fresher" : "Experienced";

			return {
				candidate: {
					...baseCandidate,
					experienceLevel: normalizedExperienceLevel,
					experienceLevelFormatted: normalizedExperienceLabel,
					designation:
						this.selected === "experienced"
							? String(this.form.designation || "").trim()
							: baseCandidate.designation || "",
					totalYearsOfExp:
						this.selected === "experienced"
							? Number(this.form.totalYearsOfExp)
							: baseCandidate.totalYearsOfExp || "",
					profileSummary: "",
					goals: this.getMappedGoalsForApi(),
					city: String(this.locationInput || "").trim(),
				},
			};
		},
		async generateProfileSummary(headers) {
			try {
				const payload = this.buildSummaryPayload();
				const response = await ServiceCandidateParser({
					url: "/ai/summary/",
					method: "post",
					headers,
					data: payload,
				});
				const summaryText = this.extractSummaryFromResponse(response);
				return summaryText;
			} catch (error) {
				this.errorModal(
					"Error",
					"Unable to generate summary. Please try again."
				);
				throw error;
			}
		},
		extractSummaryFromResponse(response) {
			const summaryText =
				response?.data?.summary || response?.data?.data?.summary || "";
			return String(summaryText || "").trim();
		},
		postGeneratedSummary(candidateId, summaryText, headers) {
			return ServiceCandidate({
				url: "can/candidate-information/",
				method: "post",
				headers,
				data: {
					id: candidateId,
					profileSummary: summaryText,
					onboardingStep: 3,
				},
			});
		},
		onSelectExperience(level) {
			this.selected = level;
			if (level === "fresher") {
				this.form.designation = "";
				this.form.totalYearsOfExp = "";
			}
			// this.resetStepTwoState();
			this.resetStepThreeState();
			this.$v.$reset();
			// saveDraft() not needed here — the `selected` and `form` deep watchers handle it.
		},
		getCandidateId() {
			return this.candidateInfo?._id || this.primaryCandidateInfo?._id || null;
		},
		draftExists() {
			const storageKey = this.getDraftStorageKey();
			if (!storageKey) return false;
			return localStorage.getItem(storageKey) !== null;
		},
		getDraftStorageKey() {
			const candidateId = this.getCandidateId();
			return candidateId ? `onboarding_draft_${candidateId}` : null;
		},
		getOnboardingSessionStorageKey() {
			const candidateId = this.getCandidateId();
			return candidateId ? `onboarding_session_${candidateId}` : null;
		},
		getOrCreateOnboardingSessionId() {
			if (this.onboardingSessionId) {
				return this.onboardingSessionId;
			}

			const storageKey = this.getOnboardingSessionStorageKey();
			if (!storageKey) {
				this.onboardingSessionId = "";
				return this.onboardingSessionId;
			}

			try {
				const existingSessionId = sessionStorage.getItem(storageKey);
				if (existingSessionId) {
					this.onboardingSessionId = existingSessionId;
					return this.onboardingSessionId;
				}

				const newSessionId = `session_${Date.now()}_${Math.random()
					.toString(36)
					.slice(2, 10)}`;
				sessionStorage.setItem(storageKey, newSessionId);
				this.onboardingSessionId = newSessionId;
				return this.onboardingSessionId;
			} catch (error) {
				this.onboardingSessionId = `session_${Date.now()}_${Math.random()
					.toString(36)
					.slice(2, 10)}`;
				return this.onboardingSessionId;
			}
		},
		isSameOnboardingSession(draftData) {
			if (!draftData || typeof draftData !== "object") {
				return false;
			}

			const activeSessionId = this.getOrCreateOnboardingSessionId();
			return !!activeSessionId && draftData.sessionId === activeSessionId;
		},
		getLastSavedStepStorageKey() {
			const candidateId = this.getCandidateId();
			return candidateId ? `onboarding_last_saved_step_${candidateId}` : null;
		},
		getLastSavedStep() {
			const storageKey = this.getLastSavedStepStorageKey();
			if (!storageKey) return null;

			try {
				const rawValue = localStorage.getItem(storageKey);
				const parsedStep = Number(rawValue);
				if (!Number.isInteger(parsedStep) || parsedStep < 1 || parsedStep > 3) {
					return null;
				}
				return parsedStep;
			} catch (error) {
				return null;
			}
		},
		setLastSavedStep(step) {
			const parsedStep = Number(step);
			if (!Number.isInteger(parsedStep) || parsedStep < 1 || parsedStep > 3) {
				return;
			}

			this.savedOnboardingStep = parsedStep;

			const storageKey = this.getLastSavedStepStorageKey();
			if (!storageKey) return;

			try {
				localStorage.setItem(storageKey, String(parsedStep));
			} catch (error) {
				// Ignore storage write failures and keep in-memory checkpoint.
			}
		},
		extractSavedOnboardingStep(data) {
			const rawStep =
				data?.onboardingStep ??
				data?.onboardingCheckpoint ??
				data?.parser?.onboardingStep ??
				data?.parser?.onboardingCheckpoint ??
				null;

			const parsedStep = Number(rawStep);
			if (!Number.isInteger(parsedStep) || parsedStep < 1 || parsedStep > 3) {
				return null;
			}

			return parsedStep;
		},
		deriveLastSavedStepFromApiStep(apiStep) {
			if (apiStep === null) {
				return 3;
			}

			const parsedStep = Number(apiStep);
			if (!Number.isInteger(parsedStep) || parsedStep < 1 || parsedStep > 3) {
				return null;
			}

			if (parsedStep === 1) {
				return null;
			}

			return parsedStep - 1;
		},
		loadDraft() {
			const storageKey = this.getDraftStorageKey();
			if (!storageKey) return; // No storage key = can't load

			try {
				const draftJson = localStorage.getItem(storageKey);
				if (!draftJson) return;

				const draftData = JSON.parse(draftJson);

				if (!draftData || typeof draftData !== "object") {
					return;
				}
				if (!this.isSameOnboardingSession(draftData)) {
					return;
				}
				this.lastDraftSnapshot = draftJson;

				// Restore persistent state
				if (
					draftData.selected &&
					["fresher", "experienced"].includes(draftData.selected)
				) {
					this.selected = draftData.selected;
				}
				if (draftData.form && typeof draftData.form === "object") {
					this.form = { ...draftData.form };
				}
				if (Array.isArray(draftData.skills)) {
					this.skills = draftData.skills.map((s) => ({ ...s }));
				}
				if (
					draftData.selectedExpertiseLevel &&
					typeof draftData.selectedExpertiseLevel === "string"
				) {
					this.selectedExpertiseLevel = draftData.selectedExpertiseLevel;
				}
				if (Array.isArray(draftData.selectedGoals)) {
					this.selectedGoals = [...draftData.selectedGoals];
				}
				if (typeof draftData.locationInput === "string") {
					this.locationInput = draftData.locationInput;
				}
				if (typeof draftData.skillInput === "string") {
					this.skillInput = draftData.skillInput;
				}
				if (draftData.step && Number.isInteger(draftData.step)) {
					this.step =
						draftData.step > 1 && !this.hasValidStepOneData()
							? 1
							: draftData.step;
				}
			} catch (error) {
				console.warn(
					"Failed to load onboarding draft from localStorage",
					error
				);
			}
		},
		hydrateRoadmapSkillsFromQuery(propValue) {
			const roadmapSkills = this.parseRoadmapSkillsQuery(
				propValue || this.$route?.query?.roadmapSkills
			);
			if (!roadmapSkills.length) return false; // No URL skills found

			const uniqueSkills = [];
			const seen = new Set();
			roadmapSkills.forEach((skillEntry) => {
				const parsedEntry = this.parseRoadmapSkillEntry(skillEntry);
				const normalized = this.normalizeSkillName(parsedEntry.skillName);
				if (!normalized || seen.has(normalized)) return;
				seen.add(normalized);
				uniqueSkills.push({
					skillName: String(parsedEntry.skillName || "")
						.trim()
						.replace(/\s+/g, " "),
					expertiseLevel: parsedEntry.expertiseLevel || "",
					yearsOfExp: "",
				});
			});

			if (!uniqueSkills.length) return false;

			// URL skills loaded successfully - prefill step 2 data but keep step 1 mandatory
			this.skills = uniqueSkills;
			this.saveDraft();
			return true;
		},
		parseRoadmapSkillsQuery(rawValue) {
			if (Array.isArray(rawValue)) {
				return rawValue
					.map((value) => String(value || "").trim())
					.filter(Boolean);
			}

			if (rawValue == null) return [];

			const rawString = String(rawValue).trim();
			if (!rawString) return [];

			const decodeSafely = (value) => {
				try {
					return decodeURIComponent(value);
				} catch (error) {
					return value;
				}
			};

			const candidates = [rawString, decodeSafely(rawString)];
			for (const candidate of candidates) {
				try {
					const parsed = JSON.parse(candidate);
					if (Array.isArray(parsed)) {
						return parsed
							.map((value) => String(value || "").trim())
							.filter(Boolean);
					}
				} catch (error) {
					// Fall through to the legacy string fallback below.
				}
			}

			return decodeSafely(rawString)
				.replace(/^\[/, "")
				.replace(/\]$/, "")
				.split(",")
				.map((value) => value.replace(/^\s*"|"\s*$/g, "").trim())
				.filter(Boolean);
		},
		clearDraft() {
			const storageKey = this.getDraftStorageKey();
			if (!storageKey) return;

			try {
				localStorage.removeItem(storageKey);
				this.lastDraftSnapshot = "";
			} catch (error) {
				console.warn(
					"Failed to clear onboarding draft from localStorage",
					error
				);
			}
		},
		//To clear the local and session storage
		clearOnboardingStorage() {
			const draftKey = this.getDraftStorageKey();
			const lastStepKey = this.getLastSavedStepStorageKey();
			try {
				if (draftKey) localStorage.removeItem(draftKey);
				if (lastStepKey) localStorage.removeItem(lastStepKey);

				localStorage.removeItem("landing_onboarding_upload_flow_active");

				// Remove all onboarding_session_ keys from sessionStorage
				for (let i = sessionStorage.length - 1; i >= 0; i--) {
					const key = sessionStorage.key(i);
					if (key && key.startsWith("onboarding_session_")) {
						sessionStorage.removeItem(key);
					}
				}
			} catch (e) {
				// Ignore storage errors
			}
		},
		async handleContinue() {
			if (this.step !== 1) {
				this.step = Math.min(this.step + 1, 3);
				return;
			}

			if (!this.selected) return;

			this.$v.form.$touch();
			if (this.selected === "experienced" && this.$v.form.$invalid) {
				return;
			}

			const candidateId = this.getCandidateId();
			if (!candidateId) {
				return;
			}

			const totalYears = Number(this.form.totalYearsOfExp);
			if (
				this.selected === "experienced" &&
				(!Number.isFinite(totalYears) ||
					totalYears < 1 ||
					totalYears > this.max ||
					!/^\d+(\.\d{1,2})?$/.test(String(this.form.totalYearsOfExp)))
			) {
				return;
			}

			const payload = {
				id: candidateId,
				experienceLevel:
					this.selected === "fresher" ? "fresher" : "intermediate",
				onboardingStep: 1,
			};

			if (this.selected === "experienced") {
				payload.designation = this.form.designation.trim();
				payload.totalYearsOfExp = totalYears;
			}

			const userID = getProcessedToken();
			const headers = userID ? { userID } : {};

			this.isSubmitting = true;
			try {
				const response = await ServiceCandidate({
					url: "can/candidate-information/",
					method: "post",
					headers,
					data: payload,
				});
				if (response?.status === 200) {
					this.setLastSavedStep(1);

					//To fetch RoadmapSkills
					if (this.skills.length === 0) {
						this.hydrateRoadmapSkillsFromQuery(this.roadmapSkills);
					}
					this.step = 2;
				} else {
					this.errorModal(
						"Error",
						"Unable to save experience details. Please try again."
					);
				}
			} catch (error) {
				this.errorModal(
					"Error",
					"Unable to save experience details. Please try again."
				);
			} finally {
				this.isSubmitting = false;
			}
		},
		saveDraft() {
			if (this.isInitialFetching) return;

			const storageKey = this.getDraftStorageKey();
			if (!storageKey) return;

			try {
				const draftData = {
					modalOpen: this.modalOpen,
					sessionId: this.getOrCreateOnboardingSessionId(),
					step: this.step,
					selected: this.selected,
					form: { ...this.form },
					skills: this.skills.map((s) => ({ ...s })),
					selectedSkillIndex: this.selectedSkillIndex,
					selectedExpertiseLevel: this.selectedExpertiseLevel,
					selectedGoals: [...this.selectedGoals],
					locationInput: this.locationInput,
					skillInput: this.skillInput,
				};
				const nextSnapshot = JSON.stringify(draftData);
				if (nextSnapshot === this.lastDraftSnapshot) return;
				localStorage.setItem(storageKey, nextSnapshot);
				this.lastDraftSnapshot = nextSnapshot;
			} catch (error) {
				console.warn("Failed to save onboarding draft to localStorage", error);
			}
		},
		async fetchAndHydrateProfile() {
			this.isInitialFetching = true;
			try {
				const response = await getCandidatePrimaryProfile();
				const profileData = response?.data?.data || response?.data || {};

				// 1. Map and Sanitize API data (Defensive Hydration)
				this.mapApiToOnboardingState(profileData);

				// 2. Determine Step Resumption from API completeness first.
				const apiStep = this.calculateLastPrefilledStep(profileData);
				const inferredSavedStep = this.deriveLastSavedStepFromApiStep(apiStep);
				const savedFromApi = this.extractSavedOnboardingStep(profileData);
				const savedFromLocal = this.getLastSavedStep();
				const lastSavedStep =
					savedFromApi ?? savedFromLocal ?? inferredSavedStep;
				this.savedOnboardingStep = lastSavedStep;

				// 3. Load LocalStorage Draft (Mid-edit fallback)
				const draftExists = this.draftExists();
				let draftData = null;
				let sameSessionDraftData = null;
				if (draftExists) {
					try {
						const draftJson = localStorage.getItem(this.getDraftStorageKey());
						draftData = JSON.parse(draftJson);
						if (this.isSameOnboardingSession(draftData)) {
							sameSessionDraftData = draftData;
						}
					} catch (e) {
						console.warn("Invalid draft format", e);
					}
				}

				// API truth: if onboarding is fully complete, always close the modal.
				// A stale draft must NOT reopen onboarding for an already-finished user.
				if (apiStep === null) {
					this.step = null;
					return;
				}

				// 5. Refresh resumes same-session active step; reopen uses last saved checkpoint.
				if (
					sameSessionDraftData &&
					Number.isInteger(sameSessionDraftData.step) &&
					sameSessionDraftData.step >= 1 &&
					sameSessionDraftData.step <= 3
				) {
					this.step = sameSessionDraftData.step;
				} else {
					this.step = apiStep;
				}

				if (sameSessionDraftData) {
					this.applyDraftMerge(sameSessionDraftData);
				}

				// Safety floor: if step 2/3 but step 1 data is missing, force back to step 1
				if (this.step > 1 && !this.hasValidStepOneData()) {
					this.step = 1;
				}
			} catch (error) {
				console.error("Failed to fetch onboarding profile from API", error);
				// Graceful fallback to localStorage only
				if (this.draftExists()) {
					this.loadDraft();
				} else {
					this.step = 1;
					this.hydrateRoadmapSkillsFromQuery(this.roadmapSkills);
				}
			} finally {
				this.isInitialFetching = false;
			}
		},
		mapApiToOnboardingState(data) {
			if (!data) return;

			// Step 1: Experience mapping
			const apiExp = data.experienceLevel;

			const isExternalRedirect =
				this.hasRoadmapSkillsFlow ||
				!!this.$route?.query?.company ||
				!!this.$route?.query?.role;

			const hasParserKey = Object.prototype.hasOwnProperty.call(data, "parser");
			const isBrandNewUser = !hasParserKey || data.parser === false;

			// Check if user has already started onboarding by looking at saved skills
			const hasStartedOnboarding =
				Array.isArray(data.skills) && data.skills.length > 0;

			if (
				(isExternalRedirect || isBrandNewUser) &&
				!this.draftExists() &&
				!hasStartedOnboarding &&
				apiExp === "fresher"
			) {
				this.selected = null;
				this.form.designation = "";
				this.form.totalYearsOfExp = "";
			} else if (apiExp === "fresher") {
				this.selected = "fresher";
				this.form.designation = "";
				this.form.totalYearsOfExp = "";
			} else if (apiExp === "intermediate" || apiExp === "experienced") {
				this.selected = "experienced";
				this.form.designation = String(data.designation || "").trim();

				const years = Number(data.totalYearsOfExp);
				if (!isNaN(years) && years >= 1 && years <= 40) {
					this.form.totalYearsOfExp = years;
				} else {
					this.form.totalYearsOfExp = "";
				}
			}

			// Step 2: Skills mapping
			if (Array.isArray(data.skills)) {
				const validLevels = ["beginner", "intermediate", "advanced", "expert"];
				this.skills = data.skills
					.map((s) => {
						const name = String(s.skillName || "").trim();
						const level = String(s.expertiseLevel || "").toLowerCase();
						return {
							skillName: name,
							expertiseLevel: validLevels.includes(level) ? level : "",
							yearsOfExp: s.yearsOfExp || "",
						};
					})
					.filter((s) => s.skillName);
			}

			// Step 3: Goals and Location mapping
			const reverseGoalMap = {};
			Object.entries(this.goalIdToApiMapping).forEach(([uiId, apiVal]) => {
				reverseGoalMap[apiVal] = uiId;
			});

			if (Array.isArray(data.goals)) {
				this.selectedGoals = data.goals
					.map((g) => reverseGoalMap[g])
					.filter(Boolean);
			}

			this.locationInput = String(data.city || data.location || "").trim();
		},
		calculateLastPrefilledStep(data) {
			// If the API confirms onboarding is fully complete, short-circuit immediately.
			if (data && data.database_demographics) {
				return null;
			}

			//Returning users back to the last saved step
			// Step 1 validation
			if (!this.selected) {
				// Step 1 not prefilled, start from step 1
				return 1;
			}

			// Validate step 1 for experienced users
			if (this.selected === "experienced") {
				if (!this.form.designation || !this.form.totalYearsOfExp) {
					return 1; // Step 1 incomplete for experienced
				}
				const years = Number(this.form.totalYearsOfExp);
				if (
					isNaN(years) ||
					years < 1 ||
					years > 40 ||
					!/^\d+(\.\d{1,2})?$/.test(String(this.form.totalYearsOfExp))
				) {
					return 1; // Invalid years
				}
			}

			// Step 1 is complete. Check Step 2: if skills not complete, step 1 is the last complete step
			if (this.skills.length === 0) {
				// No skills entered yet, last complete step is 1
				return 1;
			}

			if (this.skills.some((s) => !s.skillName || !s.expertiseLevel)) {
				// Some skills incomplete, last complete step is 1
				return 1;
			}

			// Step 2 is complete. Check Step 3: if goals/location not complete, step 2 is the last complete step
			if (this.selectedGoals.length === 0 || !this.locationInput) {
				// Missing goals or location, last complete step is 2
				return 2;
			}

			const summary = data.profileSummary || "";
			if (!summary.trim()) {
				// Missing summary, last complete step is 2
				return 2;
			}

			// All steps complete
			return null;
		},
		applyDraftMerge(draft) {
			if (!draft || typeof draft !== "object") {
				return;
			}

			if (
				draft.selected &&
				["fresher", "experienced"].includes(draft.selected)
			) {
				this.selected = draft.selected;
			}
			if (draft.form && typeof draft.form === "object") {
				this.form = { ...this.form, ...draft.form };
			}
			if (Array.isArray(draft.skills)) {
				this.skills = draft.skills
					.filter(
						(s) => s && typeof s.skillName === "string" && s.skillName.trim()
					)
					.map((s) => ({ ...s }));
			}
			if (
				Number.isInteger(draft.selectedSkillIndex) &&
				draft.selectedSkillIndex >= 0 &&
				draft.selectedSkillIndex < this.skills.length
			) {
				this.selectedSkillIndex = draft.selectedSkillIndex;
				this.selectedSkillSnapshot = {
					...this.skills[draft.selectedSkillIndex],
				};
			} else {
				this.selectedSkillIndex = null;
				this.selectedSkillSnapshot = null;
			}
			if (typeof draft.selectedExpertiseLevel === "string") {
				this.selectedExpertiseLevel = draft.selectedExpertiseLevel;
			}
			if (typeof draft.skillInput === "string") {
				this.skillInput = draft.skillInput;
			}
			if (Array.isArray(draft.selectedGoals)) {
				this.selectedGoals = [...draft.selectedGoals];
			}
			if (typeof draft.locationInput === "string") {
				this.locationInput = draft.locationInput;
			}
		},
	},
};
</script>

<style scoped>
.skill-expertise-pill {
	padding: 8px;
	background: #f1f7ff;
	border-radius: 15px;
	color: #20639b;
}
.selected-skill-expertise {
	background: #2aa869;
	border-radius: 15px;
	padding: 8px;
	color: #ffffff !important;
}
.skill-container {
	padding: 12px;
	background: rgba(32, 99, 155, 0.08);
	border-radius: 8px;
}
.exp-slider-section {
	width: 100%;
}

.exp-label {
	font-weight: 500;
	color: #344054;
}

.req {
	color: red;
}

.slider-container {
	position: relative;
	margin-top: 10px;
}

.exp-slider {
	width: 100%;
	appearance: none;
	height: 4px;
	border-radius: 4px;
	background: #d0d5dd;
	outline: none;
}

/* slider thumb */
.exp-slider::-webkit-slider-thumb {
	appearance: none;
	width: 22px;
	height: 22px;
	border-radius: 50%;
	background: #20639b;
	cursor: pointer;
}

.exp-slider::-moz-range-thumb {
	width: 22px;
	height: 22px;
	border-radius: 50%;
	background: #20639b;
	cursor: pointer;
}

.value-box {
	position: absolute;
	right: 0;
	top: -35px;
	padding: 6px 12px;
	border: 1px solid #d0d5dd;
	border-radius: 8px;
	font-weight: 500;
	background: white;
}
.exp-options {
	display: flex;
	justify-content: center;
	gap: 20px;
	margin-bottom: 20px;
}
.exp-card {
	width: 268px;
	height: 144px;
	background: #fff;
	border-radius: 8px;
	border: 1px solid rgba(140, 140, 140, 0.3);
	position: relative;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	transition: all 0.3s ease-out;
}

.exp-card:hover {
	transform: translateY(-5px);
}

/* expanding overlay */
/* .exp-card .overlay {
	width: 100px;
	height: 100px;
	position: absolute;
	background: #20639b;
	border-radius: 50%;
	top: 40px;
	left: 30px;
	transform: scale(0);
	transition: transform 0.5s ease-out;
	z-index: -5;
}
.exp-card .overlay2 {
	width: 110px;
	height: 110px;
}
.exp-card:hover .overlay,
.exp-card:hover .overlay2 {
	transform: scale(4);
} */
.exp-card .overlay,
.exp-card .overlay2 {
	width: 110px;
	height: 110px;
	position: absolute;
	background: #20639b;
	border-radius: 50%;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) scale(0);
	transition: transform 0.5s ease-out;
	z-index: 0;
}

.exp-card:hover .overlay,
.exp-card:hover .overlay2 {
	transform: translate(-50%, -50%) scale(4);
}
/* icon circle */
/* .circle {
	width: 70px;
	height: 70px;
	border-radius: 50%;
	border: 2px solid #20639b;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	z-index: 1;
	transition: all 0.3s ease-out;
} */

/* .exp-card:hover .circle {
	background: #20639b;
	border-color: #fff;
} */

/* keep content above overlay */
.exp-card span,
.exp-card img {
	/* position: relative; */
	z-index: 2;
}
.exp-card:hover span {
	color: white !important;
}
/* active state */
.exp-card.active {
	background: #20639b;
	border-color: #20639b;
}
.h-140-w-168 {
	height: 140px;
	width: 168px;
}

.modal-footer-sec {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.steps {
	display: flex;
	gap: 5px;
}

.dot {
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background: #e2e8f0;
	cursor: default;
	/* pointer-events: none; */
}

.dot.active {
	background: #20639b;
}
.selected-tick {
	position: absolute;
	top: 8px;
	right: 8px;
}
.w-80 {
	width: 80px;
}
.skill-pill {
	font-size: 12px;
	font-weight: 500;
	font-family: "montserrat", sans-serif;
	color: #20639b;
	border-radius: 20px;
	display: flex;
	align-items: center;
	background: #fff;
	border: 1px solid #8c8c8c;
	height: fit-content;
	position: relative;
	padding-right: 22px;
}
.skill-pill-sel {
	font-size: 12px;
	font-weight: 500;
	font-family: "montserrat", sans-serif;
	color: #ffffff;
	border-radius: 20px;
	display: flex;
	align-items: center;
	background: #20639b;
	border: 1px solid transparent;
	height: fit-content;
	position: relative;
	padding-right: 22px;
}
.skill-delete-icon {
	position: absolute;
	top: 6px;
	right: 4px;
	width: 15px;
	height: 15px;
}
.skill-tick-icon {
	position: absolute;
	top: 4px;
	right: 4px;
	width: 15px;
	height: 15px;
	pointer-events: none;
}
.onboard-error-text {
	color: #dc3545;
	font-size: 12px;
	display: block;
}
.onboard-error-text.expertise {
	position: absolute;
	top: 35px;
	/* left: 202px; */
	right: 0;
}
.onboard-error-text.skills {
	position: absolute;
	top: 35px;
}
.onboard-error-text.experience {
	position: absolute;
	top: 32px;
	right: 15px;
}
.onboard-error-text.location {
	position: absolute;
	/* top: 28px; */
	right: 85px;
}
</style>
<style>
.goal-grid {
	display: grid;
	grid-template-columns: repeat(3, 168px);
	gap: 16px;
	justify-content: space-between;
}
#experience-modal .modal-dialog {
	max-width: 600px;
}
@media screen and (min-width: 1028px) {
	#experience-modal .modal-body {
		padding: 24px;
	}
}
@media (max-width: 1028px) {
	.mobmt-0 {
		margin-top: 0 !important;
	}
	.goal-grid {
		display: grid;
		grid-template-columns: repeat(2, 48%);
		gap: 10px;
		justify-content: center;
	}
	#experience-modal .modal-body {
		background: #f7f9fc;
		padding-bottom: env(safe-area-inset-bottom) !important;
	}
	#experience-modal .modal-dialog {
		margin: 0;
	}
	#experience-modal .modal {
		z-index: 2070;
	}
	#experience-modal .modal-content {
		top: 0px;
		height: 100dvh;
		overflow: auto;
		padding-top: env(safe-area-inset-top);
	}
	#experience-modal .mobile-header {
		z-index: unset;
	}
	.mobilecloseicon {
		position: absolute;
		top: 13px;
		right: 8px;
	}
	.mobflexcolumn {
		flex-direction: column;
	}
	.mob-w-100 {
		width: 100%;
	}
	.mobpx-0 {
		padding-left: 0;
		padding-right: 0;
	}
	.mobw50 {
		width: 50% !important;
	}
	.mobile-main-content-screen2 {
		height: calc(100dvh - 160px);
	}
	.mobile-exp-content-screen {
		height: calc(100dvh - 200px);
	}
	.mobile-step2-main {
		height: calc(100dvh - 180px);
	}
	.bottom-85 {
		bottom: 85px !important;
	}
	.mobile-upload-resume {
		position: absolute;
		bottom: 85px;
		left: 30%;
	}
	.mobflexwrap {
		flex-wrap: wrap;
	}
	.mobh-90 {
		height: 90%;
	}
	.mobd-flex {
		display: flex;
	}
	.mob-align-center {
		align-items: center;
	}
	.mob-justify-center {
		justify-content: center;
	}
	.mobmt8 {
		margin-top: 8px;
	}
	.h-140-w-168 {
		width: 100% !important;
	}
	.step3-main-content {
		height: calc(100dvh - 150px);
		overflow: auto;
	}
	.onboard-error-text.skills {
		top: 70px !important;
	}
	.onboard-error-text.location {
		left: 0 !important ;
	}
	.onboard-error-text.experience {
		top: 55px !important;
	}
	.onboard-error-text.step2 {
		top: 32px !important;
	}
}
.ob-skilltags-disabled,
.skill-expertise-pill.ob-skilltags-disabled {
	background: rgba(236, 236, 236, 0.55) !important;
	color: #7a7a7a !important;
	border-radius: 15px;
	padding: 8px;
}
</style>
